import { Validator, RequiredRule } from "devextreme-react/validator";
import { useContext, useState } from "react";
import { useEffectOnce } from "react-use";
import LoadingIndicator from "../../../Component/LoadingIndicator";
import Field from "../../../Component/Field";
import { Button } from "devextreme-react/button";
import { SalaryCalculationContext } from "./SalaryCalculationContext";
import LookupEdit from "../../../Component/LookupEdit";
import { SelectBox } from "devextreme-react/select-box";
import { Toast } from "devextreme-react/toast";

const SalaryCalculationForm = () => {
  const { employees, periods, processState, process, setMessage, message } = useContext(
    SalaryCalculationContext
  );
  const [employeeID, setEmployeeID] = useState("ALL");
  const [periodID, setPeriodID] = useState();
  const [show, setShow] = useState(false);

  useEffectOnce(() => {});

  const onSubmit = (e) => {
    e.preventDefault();
    process({ employee_id: employeeID, period_id: periodID });
    if(message !== "Berhasil"){
      setMessage(message.message);
      setShow(true);
    }
  };

  return (
    <div>
      <Toast
        visible={show}
        message={message}
        type={"error"}
        displayTime={3000}
        onHiding={() => setShow(false)}
      />
      <div className="flex">
        <form onSubmit={onSubmit} className="sm:w-full p-1">
          <div className="">
            <Field label="Pegawai">
              <LookupEdit
                defaultValue={employeeID}
                dataSource={employees}
                onValueChanged={(value) => setEmployeeID(value)}
              >
                <Validator>
                  <RequiredRule />
                </Validator>
              </LookupEdit>
            </Field>
            <Field label="Periode">
              <SelectBox
                defaultValue={periodID}
                dataSource={periods}
                valueExpr="id"
                displayExpr="name"
                onValueChanged={({ value }) => setPeriodID(value)}
              >
                <Validator>
                  <RequiredRule />
                </Validator>
              </SelectBox>
            </Field>
            {processState.loading ? (
              <LoadingIndicator />
            ) : (
              <Button
                id="button"
                text="Process"
                type="default"
                useSubmitBehavior={true}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default SalaryCalculationForm;
